// Mesh utilities for performance: bake a multi-mesh group into ONE mesh.
// Material colors become vertex colors, so every agent (animal/visitor) shares a
// single material and renders in a single draw call instead of 3-8.
import * as THREE from 'three';
import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';

export const AGENT_MAT = new THREE.MeshStandardMaterial({ vertexColors: true, roughness: 0.85, side: THREE.DoubleSide });

export function bakeToSingleMesh(group) {
  group.updateMatrixWorld(true);
  const geos = [];
  group.traverse((o) => {
    if (!o.isMesh) return;
    const geo = o.geometry.clone().applyMatrix4(o.matrixWorld);
    const count = geo.attributes.position.count;
    const col = new Float32Array(count * 3);
    const c = o.material.color;
    for (let i = 0; i < count; i++) { col[i * 3] = c.r; col[i * 3 + 1] = c.g; col[i * 3 + 2] = c.b; }
    geo.setAttribute('color', new THREE.BufferAttribute(col, 3));
    geos.push(geo);
  });
  // Normalize to non-indexed: mixed indexed (Box/Cylinder) + non-indexed (Icosahedron)
  // geometries make mergeGeometries return null.
  const merged = mergeGeometries(geos.map((g) => (g.index ? g.toNonIndexed() : g)), false);
  const mesh = new THREE.Mesh(merged, AGENT_MAT);
  mesh.castShadow = true;
  return mesh;
}
